import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=050056da&scoped=true&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=050056da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050056da",
  null
  
)

/* custom blocks */
import block0 from "./ChangePassword.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('050056da')) {
      api.createRecord('050056da', component.options)
    } else {
      api.reload('050056da', component.options)
    }
    module.hot.accept("./ChangePassword.vue?vue&type=template&id=050056da&scoped=true&", function () {
      api.rerender('050056da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user-profile/ChangePassword.vue"
export default component.exports